import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const ExternalOrderStatesQuery = gql`
  query ($domain: String!) {
    externalOrderStates(where: { eshop: { domain: $domain }}) {
      id
      title
      type
      priority
      color
      name
      startup
      forPaidOrder
      forSentOrder
      setOrderAsPaid
    }
    languages {
      id
      value
    }
  }
`;

const CreateExternalOrderStateMutation = gql`
  mutation($externalOrderState: CreateExternalOrderStateInput!) {
    createExternalOrderState(externalOrderState: $externalOrderState) {
      id
    }
  }
`;

const UpdateExternalOrderStateMutation = gql`
  mutation($id: String!, $externalOrderState: UpdateExternalOrderStateInput!) {
    updateExternalOrderState(id: $id, externalOrderState: $externalOrderState) {
      id
    }
  }
`;

const DeleteExternalOrderStateMutation = gql`
  mutation($id: String!) {
    deleteExternalOrderState(id: $id) {
      id
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface Response {
  data: any;
}

class GetExternalOrderStatesQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
  render() {
    const {
      externalOrderStates,
      createExternalOrderState,
      updateExternalOrderState,
      deleteExternalOrderState
    }: any = this.props;
    return this.props.children({
      externalOrderStates,
      createExternalOrderState,
      updateExternalOrderState,
      deleteExternalOrderState
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(ExternalOrderStatesQuery, {
    name: 'externalOrderStates'
  }),
  graphql<IInputProps, Response>(CreateExternalOrderStateMutation, {
    name: 'createExternalOrderState'
  }),
  graphql<IInputProps, Response>(UpdateExternalOrderStateMutation, {
    name: 'updateExternalOrderState'
  }),
  graphql<IInputProps, Response>(DeleteExternalOrderStateMutation, {
    name: 'deleteExternalOrderState'
  })
)(GetExternalOrderStatesQuery);



// WEBPACK FOOTER //
// ./src/components/Query/OrderStates/OrderStates.tsx